export default __webpack_public_path__ + "static/media/3.fcb8b483.jpg";